import React, { useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import PageBanner from './PageBanner';
import FeaturedProducts from '../FeaturedProducts';
import Products from '../Products';

const CategoryGridSection = styled.section`
  padding: 1rem 2rem 3rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
`;

const CategoryCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 2rem 1.5rem;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border: 3px solid #ffd93d;

  .emoji {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
  }

  h3 {
    color: #ff6b6b;
    margin: 0 0 0.5rem 0;
    font-size: 1.3rem;
  }

  p {
    color: #555;
    font-size: 0.95rem;
    margin: 0;
    line-height: 1.5;
  }
`;

const categories = [
  {
    emoji: '🧣',
    title: 'Chicken Bandanas',
    desc: 'Fun, attitude-filled bandanas for you or your favorite farm companion.'
  },
  {
    emoji: '👙',
    title: 'Chicken Bikinis',
    desc: 'The iconic, conversation-starting Chikin Lady swimwear collection.'
  },
  {
    emoji: '👕',
    title: 'Farm Tees & Hoodies',
    desc: 'Super soft, high-quality cotton apparel built for coop or town.'
  },
  {
    emoji: '🖼️',
    title: 'Framed Chicken Art',
    desc: 'Vibrant, original artwork that brings farm joy to any wall or room.'
  }
];

const FarmApparelPage = () => {
  useEffect(() => {
    document.title = 'Farm & Chicken Apparel, Accessories & Art | Chikin Lady';
  }, []);

  return (
    <>
      <PageBanner
        badge="🌾 Farm Fashion & Lifestyle"
        title="Farm & Chicken Apparel, Accessories & Art"
        subtitle="Strut your stuff with pride! High-quality farm clothing, accessories, and gifts crafted for backyard chicken keepers, farmers, and crazy chicken ladies everywhere."
        primaryText="🛒 Explore Collection"
        primaryLink="#products"
        secondaryText="🛍️ Store Directory"
        secondaryLink="/chikin-lady-shopping"
      />

      <CategoryGridSection>
        <CategoryGrid>
          {categories.map((c, idx) => (
            <CategoryCard
              key={idx}
              whileHover={{ y: -5, scale: 1.02 }}
              transition={{ duration: 0.2 }}
            >
              <div className="emoji">{c.emoji}</div>
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </CategoryCard>
          ))}
        </CategoryGrid>
      </CategoryGridSection>

      <FeaturedProducts />
      <Products />
    </>
  );
};

export default FarmApparelPage;
